const STORAGE_KEY = "colorMode";
const HINT_KEY = "themeToggleHintSeen";
const MODES = ["light", "medium", "dark"];

function normalizePreference(value) {
	if (value === "system") {
		return "medium";
	}
	return MODES.includes(value) ? value : "light";
}

export function getStoredColorModePreference() {
	try {
		return normalizePreference(localStorage.getItem(STORAGE_KEY));
	} catch {
		return "light";
	}
}

export function applyColorMode(preference) {
	const pref = normalizePreference(preference);
	document.documentElement.setAttribute("data-color-mode", pref);
	try {
		localStorage.setItem(STORAGE_KEY, pref);
	} catch {
		// no-op
	}
}

export function getNextColorModePreference(current) {
	const pref = normalizePreference(current);
	const idx = MODES.indexOf(pref);
	return MODES[(idx + 1) % MODES.length] ?? "light";
}

export function isThemeHintSeen() {
	try {
		return localStorage.getItem(HINT_KEY) === "1";
	} catch {
		return true;
	}
}

export function markThemeHintSeen() {
	try {
		localStorage.setItem(HINT_KEY, "1");
	} catch {
		// no-op
	}
}
